module.exports = __webpack_public_path__ + "img/Traverse2.fd89ae41.png";